
import { Drawer } from "element-ui"
import { COLLECT_INIT_WIDTH, COLLECT_EXPEND_WIDTH, PAGE_SIZE } from "../collect/const.js"
import drawerHeader from "../collect/drawer-header.vue"
import list from "@/components/ware-view/list"
import collectBox from "@/components/collect"
import pagination from "@/components/ware-view/pagination"
import { getCollectProcess, getCollectList } from "@/api/collect"

export default {
  name: "CollectOrder",
  components: {
    [Drawer.name]: Drawer,
    drawerHeader,
    list,
    pagination,
    collectBox
  },
  provide() {
    return {
      getProId: () => this.params.promotionId,
      getStoreId: () => this.params.storeId,
      source: "collect",
      hideProTag: true
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    cartList: {
      type: Array,
      default: () => []
    },
    skuId: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      listLoading: false,
      visible: false,
      loading: false,
      collectInfo: {},
      expendDrawer: false,
      initWidth: 8.5,
      drawerSize: 9.2,
      curVisible: this.visible,
      wareList: [],
      params: {}, // 请求数据参数，open带过来
      pageInfo: {
        // 分页参数
        pageNum: 1,
        pageSize: PAGE_SIZE,
        total: 0
      },
      promotionIdListStr: ""
    }
  },
  computed: {
    title() {
      return (this.item.displayInfo && this.item.displayInfo.showSlogan) || ""
    },
    slotWidth() {
      return this.expendDrawer ? COLLECT_EXPEND_WIDTH - COLLECT_INIT_WIDTH : 0
    }
  },
  watch: {},
  mounted() {
    this.$bus.$off("inner-drawer")
    this.$bus.$off("reload-collect")
    this.$bus.$on("inner-drawer", bol => {
      this.expendDrawer = bol
      this.drawerSize = bol ? COLLECT_EXPEND_WIDTH : COLLECT_INIT_WIDTH
    })
    this.$bus.$on("reload-collect", val => {
      this.getProcess()
    })
  },
  methods: {
    open(params) {
      this.visible = true
      this.loading = true
      this.params = params
      this.resetPageInfo()
      this.init()
    },
    close() {
      this.collectInfo = {}
      this.wareList = []
      this.visible = false
    },
    async init() {
      this.resetPageInfo()
      if (this.params.bestOffer) {
        const res = await this.getProcess()
        if (res && res.promotionTags) {
          const promotionIdList = res.promotionTags.map(v => v.promotionId)
          this.promotionIdListStr = promotionIdList.join(",")
        }
        await this.getList({
          promotionIdListStr: this.promotionIdListStr
        })
        this.params.title = this.$t("collect.bestOfferTitle")
      } else {
        await Promise.all([this.getProcess(), this.getList()])
      }
      this.loading = false
      this.$bus.$emit("getCartSkuList", this.cartList)
    },
    async getList(params = {}) {
      this.wareList = []
      try {
        const { data: res } = await getCollectList({
          value: this.params.promotionId,
          bestOffer: this.params.bestOffer,
          storeId: this.params.storeId,
          limit: this.pageInfo.pageSize,
          // offset: (this.pageInfo.pageNum - 1) * PAGE_SIZE,
          pageNum: this.pageInfo.pageNum,
          ...params
        })
        if (res && res.makeUpDate) {
          this.wareList = res.makeUpDate.map(item => {
            return {
              ...item,
              wareName: item.name,
              wareImg: item.imgUrl,
              warePrice: item.originalPrice,
              sku: item.skuId,
              promotionWareVO: {
                unitProPrice: item.promotionPrice,
                marketPrice: item.originalPrice,
                showLinePrice: item.originalPrice !== item.promotionPrice,
                promotionInfoList: item.promotionTags.map(proItem => ({
                  displayInfo: {
                    proTag: proItem
                  }
                }))
              }
            }
          })
        }
        if (res && res.pageInfo) {
          this.pageInfo = {
            pageNum: res.pageInfo.pageNum,
            pageSize: PAGE_SIZE,
            total: res.pageInfo.total
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getProcess(params = {}) {
      try {
        const { data: res } = await getCollectProcess({
          promotionId: this.params.promotionId,
          bestOffer: this.params.bestOffer,
          storeId: this.params.storeId,
          skuId: this.params.skuId,
          ...params
        })
        this.collectInfo = res
        return res
      } catch (err) {
        console.log(err)
      }
    },
    resetPageInfo() {
      this.pageInfo = {
        pageNum: 1,
        pageSize: PAGE_SIZE,
        total: 0
      }
    },
    setScrollTop() {
      const ref = this.$refs.collectOrderListWrapper
      if (ref && ref.$el) {
        ref.$el.scrollTop = 0
      }
    },
    async handleChange(value) {
      this.pageInfo.pageNum = value
      this.listLoading = true
      if (this.params.bestOffer) {
        await this.getList({
          promotionIdListStr: this.promotionIdListStr
        })
      } else {
        await this.getList()
      }
      this.listLoading = false
    }
  }
}
